<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtanexo) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Validade</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtvalidade) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Tipo Anexo</label>
                <div class="field-label">{{ objView.nmanexogrupo }}</div>
            </div>
        </div>

        
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Tipo do Documento</label>
                <div class="field-label">{{ objView.nmtpdoc }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Identificação</label>
                <div class="field-label">{{ objView.nmdoc }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Assinatura</label>
                <div class="field-label">{{ objView.fhash }}</div>
            </div>
        </div>

        
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ objView.nmsim }}</div>
            </div>
        </div>

        
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Formato</label>
                <div class="field-label">{{ objView.tiponm }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Situação</label>
                <div class="field-label">{{ objView.situacaonm }}</div>
            </div>
        </div>
        
        
        <div class="row-end">
            <button type="button" @click="visualizarAnexo">Abrir Anexo</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const isLoading = ref(false);
const msgAlerta = ref(null);
const objView = ref({});

const closeForm = () => {emit('close');}


const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/anexos', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


const visualizarAnexo = async() => {
    try {
        msgAlerta.value = null;
        isLoading.value = true;      
        
        if (objView.value.storage_cdtipo === 2){
            const r = await Api.genericPost('/operacoes/solicitar/download', {id: objView.value.id});
            if (r.bolok === 1){
                const url = r.download_url;
                window.open(url, '_blank');
            }
        }else{
            const response = await Api.genericAnexo(objView.value.id);
            const pdfBlob = new Blob([response], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


onMounted(lerDados);
</script>